export default function Dropdown({
  label,
  id,
  name,
  value = "",
  options = [],
  disabled = false,
  required = false,
  onChange,
  className = "",
}) {
  const inputId = id || name;

  const hasSelectedOption = options.some((option) => option.value === value);
  const selectedValue = hasSelectedOption ? value : options[0]?.value ?? "";

  return (
    <div className={className}>
      <div className="relative">
        <div
          className={`flex min-w-0 overflow-hidden border border-b-4 bg-white transition focus-within:border-gray-500
            ${disabled ? "bg-gray-100" : ""}
          `}
        >
          <select
            id={inputId}
            name={name}
            value={selectedValue}
            disabled={disabled}
            required={required}
            onChange={onChange}
            className="block min-w-0 flex-1 appearance-none border-0 bg-transparent px-4 py-2 pr-10 outline-none disabled:cursor-not-allowed"
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2">
            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              <path
                d="M5 7.5L10 12.5L15 7.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <InputLabel htmlFor={inputId} label={label} required={required}/>
      </div>
    </div>
  );
}

function InputLabel({ htmlFor, label, required }) {
  if (!label) {
    return null;
  }

  return (
    <label htmlFor={htmlFor} className="absolute left-3 top-0 -translate-y-1/2 bg-white px-1 text-xs text-gray-500">
      {label}
      {required && (
        <span className="text-base text-red-500">
          {" "}*
        </span>
      )}
    </label>
  );
}